import { render, staticRenderFns } from "./WallLocationsBlockSettings.vue?vue&type=template&id=33373068"
import script from "./WallLocationsBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallLocationsBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports